import { customScrollbar, getRem, BREAKPOINTS, transitionAnimation } from 'lib/core';
import { animated } from 'react-spring/web.cjs';
import styled from 'styled-components';

const StyledMenuContainer = styled(animated.div)`
  ${customScrollbar};
  ${transitionAnimation('opacity')};
  background-color: ${({ theme }) => theme.color.additional.light.value};
  border: ${({ theme }) => theme.border.menu.value};
  border-radius: ${({ theme }) => theme.size.borderRadius.large.value};
  box-shadow: ${({ theme }) => theme.elevation[4].value};
  box-sizing: border-box;
  margin-top: ${getRem('1px')};
  margin: 0;
  max-height: ${getRem('288px')};
  max-width: ${getRem('280px')};
  min-width: ${getRem('128px')};
  opacity: ${({ $animateMenu }) => ($animateMenu ? 1 : 0)};
  overflow-y: auto;
  position: fixed;
  width: auto;
  z-index: ${({ theme }) => theme.zIndex.dropdownMenu.value};

  @media ${BREAKPOINTS.L} {
    max-height: ${getRem('208px')};
  }
`;

export { StyledMenuContainer };
